import React, { Component } from 'react';
import Nav from '../../components/nav/Nav';
import Footer from '../../components/footer/Footer';
import langIsEn from '../../utils/langIsEn';
import classnames from 'classnames';
import Loading from '../../components/loading-v2/LoadingV2';
import BaseMeta from '../../components/base-meta/BaseMeta';
import styles from './Contact.css';

const fbImgUrl = process.env.PUBLIC_URL + '/imgs/contact/fb.png';
const igImgUrl = process.env.PUBLIC_URL + '/imgs/contact/ig.png';
const beImgUrl = process.env.PUBLIC_URL + '/imgs/contact/be.png';
const mapImgUrl = process.env.PUBLIC_URL + '/imgs/contact/map.jpg';
const studioImgUrl = process.env.PUBLIC_URL + '/imgs/contact/studio__07.jpg';

class Contact extends Component {
  constructor(props) {
    super(props);
    this.onLangChange = this.onLangChange.bind(this);
  }

  state = {
    langIsEn: langIsEn(),
    loadingAnimDone: false,
  };

  onLangChange() {
    this.setState({ langIsEn: langIsEn() });
  }

  renderMainContain() {
    const { langIsEn } = this.state;

    return (
      <div className={classnames(styles.contactSection, 'row')}>
        <div className={classnames(styles.contactTitle, 'col--m-6of12')}>
          <h1>
            Five Metal Shop
            <br />
            is a creative studio
            <br />
            that designs
            <br />
            business.
          </h1>
        </div>
        <div
          className={classnames(
            styles.contactInfo,
            'col--m-5of12',
            'col--m-offset-1of12',
          )}
        >
          {langIsEn && (
            <div>
              <p>
                <span className={styles.title}>Five Metal Shop Ltd.</span>
                <br />
                1F., No. 12-4, Ln. 12, Qingtian St.,
                <br />
                Da’an Dist., Taipei City 106, Taiwan
                <br />
                hello@fivemetalshop.com
                <br />
                +886-2-23569377
                <br />
              </p>
            </div>
          )}
          {!langIsEn && (
            <div>
              <p>
                <span className={styles.title}>Five Metal Shop Ltd.</span>
                <br />
                106 台北市大安區青田街12巷12-4號1樓
                <br />
                hello@fivemetalshop.com
                <br />
                +886-2-23569377
                <br />
              </p>
            </div>
          )}
          <div>
            <a
              href="https://www.facebook.com/FiveMetalShop"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={fbImgUrl}
                alt="links"
                className={styles.img}
                width="39"
              />
            </a>
            <a
              href="https://www.instagram.com/fivemetalshop/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={igImgUrl}
                alt="links"
                className={styles.img}
                width="39"
              />
            </a>
            <a
              href="https://www.behance.net/fivemetalshop"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={beImgUrl}
                alt="links"
                className={styles.img}
                width="39"
              />
            </a>
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (!this.state.loadingAnimDone) {
      setTimeout(() => this.setState({ loadingAnimDone: true }), 500);
      return (
        <BaseMeta path={this.props.location.pathname} title="Contact">
          <Loading hide />
        </BaseMeta>
      );
    }

    return (
      <main className={'animated fadeIn'}>
        <BaseMeta path={this.props.location.pathname} title="Contact" />
        <Nav activeItem="contact" onLangChange={this.onLangChange} />
        <div className="container">
          {this.renderMainContain()}
          <div className="animated fadeInUp" style={{ paddingBottom: '25px' }}>
            <div className="row">
              <div className="col--m-6of12">
                <div className="four-three">
                  <div className={classnames(styles.placeholder, 'content')}>
                    <img src={studioImgUrl} alt="fms studio people" />
                  </div>
                </div>
              </div>
              <div className="col--m-6of12">
                <div className="four-three">
                  <div className={classnames(styles.placeholder, 'content')}>
                    <a
                      href="https://goo.gl/maps/njeJDst7UXQ2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={mapImgUrl} alt="fms map address" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </main>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/containers/contact/Contact.js